"use strict";
// Represent various types of plex
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlToRoute = exports.routeToUrl = exports.routeToUrlComponents = void 0;
const assert_never_1 = require("assert-never");
const Routes_1 = require("./Routes");
const PLEX_HOST = 'https://app.plexhq.io';
const PLEX_PERMALINK_REGEXP = new RegExp('^/plex/\\d+/?$');
const POST_PERMALINK_REGEXP = new RegExp('^/plex/\\d+/post/\\d+/?$');
const EVENT_PERMALINK_REGEXP = new RegExp('^/plex/\\d+/event/\\d+/?$');
const QUESTION_PERMALINK_REGEXP = new RegExp('^/plex/\\d+/question/\\d+/?$');
const TASK_PERMALINK_REGEXP = new RegExp('^/plex/\\d+/task/\\d+/?$');
const ROUTE_SEARCH_OBJECT_KEYS = [
    'commentsVisible',
    'page',
    'selectedPlex',
    'searchQuery',
    'prevPage',
    'filterTasksItemType',
    'filterTimelineInterval',
    'filterTimelineItemType',
    'filterPlexIds',
    'filterLabelIds',
    'filterPublishStatus',
    'tasksOrder',
];
// We could pass in here directly selectedItemType, however that would
// lose the distinction between 'event' and 'post' which is encoded using same type ('post')
function getDefaultPage(pathname) {
    if (pathname.match(POST_PERMALINK_REGEXP)) {
        return 'feed';
    }
    else if (pathname.match(EVENT_PERMALINK_REGEXP)) {
        return 'timeline';
    }
    else if (pathname.match(QUESTION_PERMALINK_REGEXP)) {
        return 'base';
    }
    else if (pathname.match(TASK_PERMALINK_REGEXP)) {
        return 'tasks';
    }
    else {
        return 'feed';
    }
}
function routeToSearchObject(route, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        page: route.page != getDefaultPage(options.pathname) ? route.page : undefined,
        selectedPlex: (_a = route.plexSummary) === null || _a === void 0 ? void 0 : _a.permalink,
        prevPage: (_b = route.searchFilters) === null || _b === void 0 ? void 0 : _b.previousPage,
        searchQuery: ((_c = route.searchFilters) === null || _c === void 0 ? void 0 : _c.query) != null && route.searchFilters.query.length > 0
            ? route.searchFilters.query
            : undefined,
        filterTasksItemType: ((_d = route.tasksFilters) === null || _d === void 0 ? void 0 : _d.itemType) != 'MILESTONE' ? ((_e = route.tasksFilters) === null || _e === void 0 ? void 0 : _e.itemType) || 'ALL' : undefined,
        filterTimelineInterval: ((_f = route.timelineFilters) === null || _f === void 0 ? void 0 : _f.timeInterval) != null && route.timelineFilters.timeInterval.type != 'this_week'
            ? JSON.stringify(route.timelineFilters.timeInterval)
            : undefined,
        filterTimelineItemType: (_g = route.timelineFilters) === null || _g === void 0 ? void 0 : _g.itemType,
        filterPlexIds: ((_h = route.filters) === null || _h === void 0 ? void 0 : _h.plexIds) != null && route.filters.plexIds.length > 0
            ? JSON.stringify(route.filters.plexIds)
            : undefined,
        filterLabelIds: ((_j = route.filters) === null || _j === void 0 ? void 0 : _j.labelIds) != null && route.filters.labelIds.length > 0
            ? JSON.stringify(route.filters.labelIds)
            : undefined,
        filterPublishStatus: (_k = route.filters) === null || _k === void 0 ? void 0 : _k.publishStatus,
        tasksOrder: ((_l = route.tasksFilters) === null || _l === void 0 ? void 0 : _l.order) !== 'DUE_DATE_ASC' ? (_m = route.tasksFilters) === null || _m === void 0 ? void 0 : _m.order : undefined,
    };
}
function routeToUrlComponents({ route, search = '', }) {
    const { path, searchObject, rest } = (() => {
        // Determine path by finding highest priority content
        if (route.selectedItem != null) {
            const { selectedItem } = route, rest = __rest(route, ["selectedItem"]);
            switch (selectedItem.type) {
                case 'post':
                case 'question':
                case 'task': {
                    return {
                        path: selectedItem.permalink,
                        searchObject: selectedItem.commentsVisible ? { commentsVisible: '' } : {},
                        rest,
                    };
                }
            }
        }
        if (route.plexSummary != null) {
            const { plexSummary } = route, rest = __rest(route, ["plexSummary"]);
            return {
                path: plexSummary.permalink,
                searchObject: {},
                rest,
            };
        }
        const { page } = route, rest = __rest(route, ["page"]);
        const path = (() => {
            switch (page) {
                case 'feed':
                    return Routes_1.Routes.PLEX_FEED_PATH;
                case 'timeline':
                    return Routes_1.Routes.TIMELINE_PATH;
                case 'base':
                    return Routes_1.Routes.PLEX_BASE_PATH;
                case 'tasks':
                    return Routes_1.Routes.PLEX_TASKS_PATH;
                case 'notifications':
                    return Routes_1.Routes.NOTIFICATIONS_PATH;
                case 'search':
                    return Routes_1.Routes.PLEX_SEARCH_PATH;
                default:
                    assert_never_1.assertNever(page);
            }
        })();
        return {
            path,
            searchObject: {},
            rest,
        };
    })();
    const urlSearchParams = new URLSearchParams(search);
    // Delete existing query params that are set via `PlexRoute`
    ROUTE_SEARCH_OBJECT_KEYS.forEach((key) => urlSearchParams.delete(key));
    const searchParamsToAdd = Object.assign(Object.assign({}, searchObject), routeToSearchObject(rest, { pathname: path }));
    Object.entries(searchParamsToAdd).forEach(([key, value]) => {
        if (value != null) {
            urlSearchParams.set(key, value);
        }
    });
    return {
        pathname: path,
        search: urlSearchParams.toString(),
    };
}
exports.routeToUrlComponents = routeToUrlComponents;
function routeToUrl({ host = PLEX_HOST, route, search = '', }) {
    const { pathname, search: updatedSearch } = routeToUrlComponents({ route, search });
    if (updatedSearch.length > 0) {
        return `${host}${pathname}?${updatedSearch}`;
    }
    else {
        return `${host}${pathname}`;
    }
}
exports.routeToUrl = routeToUrl;
function urlToRoute({ pathname, search }) {
    // Import state from search string
    const searchParams = {};
    new URLSearchParams(search).forEach((value, key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        searchParams[key] = value;
    });
    // FIXME: should validate enums from query params
    const pathBasedRoute = (() => {
        if (pathname.match(PLEX_PERMALINK_REGEXP)) {
            return {
                page: searchParams.page || getDefaultPage(pathname),
                plexSummary: { permalink: pathname },
            };
        }
        else if (pathname.match(POST_PERMALINK_REGEXP) || pathname.match(EVENT_PERMALINK_REGEXP)) {
            return {
                page: searchParams.page || getDefaultPage(pathname),
                selectedItem: { type: 'post', permalink: pathname, commentsVisible: searchParams.commentsVisible != null },
            };
        }
        else if (pathname.match(QUESTION_PERMALINK_REGEXP)) {
            return {
                page: searchParams.page || getDefaultPage(pathname),
                selectedItem: { type: 'question', permalink: pathname, commentsVisible: searchParams.commentsVisible != null },
            };
        }
        else if (pathname.match(TASK_PERMALINK_REGEXP)) {
            return {
                page: searchParams.page || getDefaultPage(pathname),
                selectedItem: { type: 'task', permalink: pathname },
            };
        }
        else if (pathname === Routes_1.Routes.PLEX_FEED_PATH) {
            return {
                page: 'feed',
            };
        }
        else if (pathname === Routes_1.Routes.TIMELINE_PATH) {
            return {
                page: 'timeline',
            };
        }
        else if (pathname === Routes_1.Routes.PLEX_BASE_PATH) {
            return {
                page: 'base',
            };
        }
        else if (pathname === Routes_1.Routes.PLEX_TASKS_PATH) {
            return {
                page: 'tasks',
            };
        }
        else if (pathname === Routes_1.Routes.NOTIFICATIONS_PATH) {
            return {
                page: 'notifications',
            };
        }
        else if (pathname === Routes_1.Routes.PLEX_SEARCH_PATH) {
            return {
                page: 'search',
            };
        }
        else {
            return {
                page: searchParams.page || getDefaultPage(pathname),
            };
        }
    })();
    // FIXME: should have try catch around JSON.parse and fallback to undefined
    return Object.assign(Object.assign(Object.assign(Object.assign({}, (searchParams.selectedPlex != null ? { plexSummary: { permalink: searchParams.selectedPlex } } : {})), (searchParams.searchQuery != null
        ? { searchFilters: { query: searchParams.searchQuery, previousPage: searchParams.prevPage } }
        : {})), { tasksFilters: {
            itemType: searchParams.filterTasksItemType != 'ALL' ? searchParams.filterTasksItemType || 'MILESTONE' : undefined,
            order: searchParams.tasksOrder,
        }, timelineFilters: Object.assign(Object.assign({}, (searchParams.filterTimelineInterval != null
            ? { timeInterval: JSON.parse(searchParams.filterTimelineInterval) }
            : {})), { itemType: searchParams.filterTimelineItemType }), filters: Object.assign(Object.assign(Object.assign({}, (searchParams.filterPlexIds != null ? { plexIds: JSON.parse(searchParams.filterPlexIds) } : {})), (searchParams.filterLabelIds != null ? { labelIds: JSON.parse(searchParams.filterLabelIds) } : {})), { publishStatus: searchParams.filterPublishStatus }) }), pathBasedRoute);
}
exports.urlToRoute = urlToRoute;
//# sourceMappingURL=plexRouteV2.js.map